import { SVGProps } from 'react';
import Icon from '../../Icon';

/** Fills its wrapper (LineRoundedWrapper sets the size); `stroke` sets the colour. */
const LineRoundedEmail = ({ stroke, color }: SVGProps<SVGElement>) => (
  <Icon name="email" size="100%" color={stroke ?? color} />
);

export { LineRoundedEmail };
